<template>
    <CustomHeader :text="$t('bauDoTesouro.treasure')" />
    <div class="bauContainer">
        <van-row>
            <van-col :span="24">
                <img class="treasureTopImage" :src="dataSet.bannerIcon" alt="">
            </van-col>
        </van-row>

        <van-row class="secContainer">
            <van-col :span="24">
                <div class="menuLinkCont">
                    <div class="menuLinkWrapper">
                        <!-- <img style="width: 100%; position: relative;" src="@/assets/bauDo/menuLink_share_frame.png"
                            alt=""> -->
                        <p class="menueLinkTxt">{{ $t('common.myLink') }}</p>
                        <InputField class="inputFieldOverlay" :modelValue="dataSet.activityConfig?.link" />
                        <p class="menueLinkBtTxt">{{ $t('common.quickShare') }}</p>
                        <div style="position: absolute; display: flex;" class="mediaListMain">
                            <div v-for="(item, index) in mediaList" :key="index" class="mediaList" @click="goToShare"
                                style="display: flex; flex-direction: column; justify-content: center;align-items: center; padding: 8px;">
                                <img :src="item.icon" style="height: 24.75px; width: 24.75px;" class="" alt="">
                                <p style="color:#b4e6ec; font-size: 9px;">{{ $t(item.name) }}</p>
                            </div>
                        </div>

                    </div>
                    <div @click="goToUserDetails"
                        style="margin-top: 15px; background: linear-gradient(90deg, #c854ad 0%, #432e4f 100%); border-radius: 10px;">
                        <van-row style="padding: 0px 10px;">
                            <van-col span="15">
                                <p style="color: #ffffffd9; font-size: 13.98px;">{{ $t('bauDoTesouro.myReports') }}</p>
                            </van-col>
                            <van-col span="7"
                                style="color: #F0A853; font-size: 13.98px; display: flex; justify-content: flex-end; flex-direction: row;">
                                <p style="color: #F0A853; font-size: 15px; display: flex; justify-content: flex-end;">{{
                                    dataSet.activityConfig?.valid_user_count }}</p>
                                <p
                                    style="color: #F0A853; font-size: 11px; align-items: center; display: flex; margin-left: 5px; justify-content: flex-end;">
                                    {{ $t('common.pepole') }} </p>
                            </van-col>
                            <van-col span="2" style="display: flex; justify-content: flex-end; align-items: center;">
                                <img style="height: 24.75px; width: 24.75px;" src="@/assets/bauDo/arrow.png" alt="">
                            </van-col>
                        </van-row>
                    </div>
                    <div class="recordsCard">
                        <van-row class="cardRow">
                            <div v-for="(value, index) in zigzagReordered" :key="index" class="cardCol"
                                style="width: 25%;">
                                <div v-if="!value.isNullObject">
                                    <RewardBox :peopleCount="value.valid_count" :reward="value.reward"
                                        :side="value.side" :down="value.turnDown" :isInCorner="value.isInCorner"
                                        :received="value?.received" :isLast="value.isLast" />
                                    <div class="arrowImg"
                                        v-if="value.side == 'left' && !value.turnDown && !value.isLast">
                                        <img src="@/assets/bauDo/next.png" alt="">
                                    </div>
                                    <div class="arrowImgRight" v-if="value.side == 'right' && (value.displayIndex < 3)">
                                        <img src="@/assets/bauDo/next.png" alt="">
                                    </div>
                                    <div class="arrowDownImg" v-if="value.turnDown && !value.isLast">
                                        <img src="@/assets/bauDo/next.png" alt="">
                                    </div>
                                </div>

                            </div>
                        </van-row>
                    </div>


                </div>
            </van-col>
        </van-row>

        <div class="bottom_text">
            <div class="title">{{ $t("common.activityTitle") }}</div>
            <div class="line_text" v-for="(item, index) in dataSet.descriptionHtml" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, defineEmits, ref, defineProps } from 'vue';
import InputField from './components/inputField.vue';
import RewardBox from './components/rewardBox.vue';
import { toZigZagWithFlags, toZigZagWithFlagsAdvance } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import { MEDIA_LIST, TreasureData } from '@/view/bauDoTesouro/supportScript';

const mediaList = ref(MEDIA_LIST)

const props = defineProps<{
    dataSet: TreasureData
}>()

const emits = defineEmits(['goToShare', 'goToUserDetails'])
const zigzagReordered = computed<any>(() => {
    return toZigZagWithFlagsAdvance(props.dataSet.activityConfig?.reward_conf, 4);
})

const goToShare = async () => {
    emits('goToShare')
}
const goToUserDetails = async () => {
    emits('goToUserDetails')
}

</script>
<style scoped>
.bauContainer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: #221b24;
    padding: 0px 10px;
}


.treasureTopImage {
    width: 100%;
    padding-top: 44px;
}

.secContainer {
    display: flex;
    justify-content: center;
    padding: 0px 15px;
    flex-direction: column;
    margin-top: 0;
}

.menuLinkWrapper {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25vh;
    background-color: #3f2e4b;
    border-radius: 10px;
}

.inputFieldOverlay {
    position: absolute;
    top: 15%;
    width: 87%;

}

.mediaListMain {
    position: absolute;
    top: 65%;
    z-index: 1;
}

.menuLinkCont {}

.rewardCard {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.menueLinkTxt {
    color: #ffffffd9;
    font-size: 14px;
    position: absolute;
    top: 0%;
    left: 7%;
    display: flex;
    justify-content: flex-start;
    z-index: 1;

}

.menueLinkBtTxt {
    color: #ffffffd9;
    font-size: 14px;
    position: absolute;
    top: 47%;
    display: flex;
    justify-content: flex-start;
    z-index: 1;

}

.active_channel {
    color: #fff;
    background-color: #00bbbb;
    border: 1px solid hsla(0, 0%, 100%, .45);
}

.bottom_text {
    padding: 25px;
}

.title {
    color: #7a4289;
    font-weight: bold;
    font-size: 15px;
    padding: 10px 0;
}

.line_text {
    color: #86718c;
    font-size: 13px;
    padding: 5px;
}

.recordsCard {
    padding-left: 10%;
    background: #312734;
    margin-top: 2%;
    border-radius: 10px;
    max-height: 50vh;
    overflow: hidden;
    overflow-y: scroll;
}

.recordsCard::-webkit-scrollbar {
    display: none;
}

.cardRow {
    background-size: contain;
    width: 100%;
}

.cardRow img {
    width: 90%;
}

.cardCol {
    position: relative;
    display: flex;
    margin-bottom: 10%;

}

.arrowImg img {
    width: 40%;
    position: absolute;
    top: 30%;
    right: 0%;
    z-index: 1;
}

.arrowImgRight img {
    width: 40%;
    position: absolute;
    top: 30%;
    right: 10%;
    rotate: 180deg;
    z-index: 1;
}

.arrowDownImg img {
    width: 40%;
    position: absolute;
    bottom: -45%;
    left: 5%;
    rotate: 90deg;
}

@media (max-width:450px) {
    .arrowDownImg img {
        bottom: -15%;
        left: 15%;
    }
}
</style>